import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListSuppliersComponent } from './components/list-suppliers/list-suppliers.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [
    ListSuppliersComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
  ]
})
export class SuppliersModule { }
